/**************************************************
 * Nombre:       Home_Registra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import foto from '../../../Recursos/registra.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Registra = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(90deg, #91DDCF 0%, rgba(255, 255, 255, 0.00) 100%)',
                overflowX: 'hidden'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >


                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: !masSM ? 6 : 2}}>
                                    <Typography sx={{
                                        lineHeight: 1.1,
                                        fontSize: !masSM ? 32 : 64,
                                        fontWeight: 800,
                                        textAlign: sCell ? 'center' : 'left'
                                    }}>
                                        <span style={{color: theme.palette.primary.main}}>
                                            ¡Registra tu Droguería
                                        </span>
                                        <br/>
                                        y vende en nuestro marketplace!

                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 8}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        textAlign: sCell ? 'center' : 'left'
                                    }}>
                                        Utiliza nuestras herramientas interactivas para vender online, no solo vendas,
                                        transforma vidas: nuestra IA sugiere lo que tu cliente realmente necesita.

                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4, mb: !masSM ? 6 : 0}}>
                                    <Button sx={{borderRadius: 14, px: 6, pt: 1.4, pb: 1.2}}>Más Información</Button>
                                </Grid>


                            </Grid>
                        </Grid>

                        {masSM &&
                            <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <img src={foto} width={'140%'} height={'auto'}/>
                            </Grid>
                        }

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Registra